import dayjs from "dayjs";
import { useEffect } from "react";

type UseDatesGuardParams = {
  departureDate: Date | null;
  returnDate: Date | null;
  setReturnDate: (date: Date | null) => void;
};

export function useDatesGuard(params: UseDatesGuardParams) {
  const { departureDate, returnDate, setReturnDate } = params;

  useEffect(() => {
    if (
      returnDate &&
      departureDate &&
      dayjs(returnDate).isBefore(dayjs(departureDate))
    ) {
      setReturnDate(departureDate);
    }
  }, [departureDate, returnDate, setReturnDate]);
}
